import router from './router'
import store from './store'
import { l } from './router'

import { Message } from 'element-ui'
import { getToken } from './servises/token' // getToken from cookie


const whiteList = ['/login']

router.beforeEach((to, from, next) => {
    if (getToken()) {
        if (to.path === '/login') {
            next({ path: '/' })
        } else {
            if (!store.getters.userData) {
                store.dispatch('GetInfo').then( res => {
                    next()
                }).catch((err) => {
                    store.dispatch('FedLogOut').then(() => {
                        Message.error(err || 'Verification failed, please login again')
                        next({ path: '/' })
                    })
                })
            } else {
                next()
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login`)
        }
    }

})

export function hasRolePermission(roleNames = []) {
    const user = store.getters['userData'];

    if (user.roles.some(role => role.name === 'administrator')) {
        return true
    }

    return user.roles.some(role => roleNames.includes(role.name));
}

router.afterEach((to, from) => {
    if(to && to.meta && to.meta.layout){
        l.set(to.meta.layout)
    }
    setTimeout(()=>{
        store.commit('setSplashScreen', false)
    }, 500)
})
